import styles from "./ChatAudioPlayer.module.css";

import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import React from "react";

export default function ChatAudioPlayer({ src, onPlay }) {
	return (
		<div className={styles.player}>
			<AudioPlayer
				src={src}
				style={{
					width: "250px",
					backgroundColor: "transparent",
					border: "none",
					boxShadow: "none",
				}}
				onPlay={onPlay}
				showJumpControls={false}
				autoPlayAfterSrcChange={false}
				layout="horizontal-reverse"
				customProgressBarSection={[
					RHAP_UI.PROGRESS_BAR,
					RHAP_UI.DURATION,
				]}
				customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
				customAdditionalControls={[]}
				// customIcons={{
				// 	play: (
				// 		<span
				// 			className={classnames(
				// 				styles.playButton,
				// 				icons["icon-play"]
				// 			)}
				// 		/>
				// 	),
				// }}
			/>
		</div>
	);
}
